import { Model } from '@/models/Model';
export class GoalPlannerNote extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'GoalPlannerNote';
        this.$endpoint = '/goalplanner-notes';
        this.$fillable = [
            'note',
            'start_date',
            'end_date',
            'recurrence',
            'recurring_days',
        ];
    }
    fetchGroupNotes(groupId) {
        return this.request('get', `/groups/${groupId}${this.$endpoint}`, {});
    }
    fetchGroupNote(groupId, noteId) {
        return this.request('get', `/groups/${groupId}${this.$endpoint}/${noteId}`, {});
    }
    async createGroupNote(groupId, noteData) {
        return this.request('post', `/groups/${groupId}${this.$endpoint}`, noteData);
    }
    async updateGroupNote(groupId, noteId, noteData) {
        return this.request('put', `/groups/${groupId}${this.$endpoint}/${noteId}`, noteData);
    }
    async deleteGroupNote(groupId, noteId, date) {
        if (date) {
            return this.request('delete', `/groups/${groupId}${this.$endpoint}/${noteId}/${date}`, {});
        }
        return this.request('delete', `/groups/${groupId}${this.$endpoint}/${noteId}`, {});
    }
}
export var GoalPlannerNoteIncludes;
(function (GoalPlannerNoteIncludes) {
    GoalPlannerNoteIncludes["AUTHOR"] = "author";
})(GoalPlannerNoteIncludes || (GoalPlannerNoteIncludes = {}));
export var GoalPlannerNoteRecurrence;
(function (GoalPlannerNoteRecurrence) {
    GoalPlannerNoteRecurrence["NONE"] = "none";
    GoalPlannerNoteRecurrence["DAILY"] = "daily";
    GoalPlannerNoteRecurrence["WEEKLY"] = "weekly";
    GoalPlannerNoteRecurrence["MONTHLY"] = "monthly";
    GoalPlannerNoteRecurrence["YEARLY"] = "yearly";
})(GoalPlannerNoteRecurrence || (GoalPlannerNoteRecurrence = {}));
